import axios from "axios";
import sha1 from "sha1";
import { API_SECRET, apiInstance, CLOUD_NAME, UPLOAD_PRESETS_CLOUDINARY } from ".";


// export const _PE = async (numProducts , page , search ="" ,segmentFields={segments:"",fields:""}) =>{
//     const res = (await apiInstance.get(`/product?limit=${numProducts}&skip=${page}&search=${search}&${segmentFields.segments && `segments=${segmentFields.segments}`}&${segmentFields.fields && `fields=${segmentFields.fields}`}`)).data
//     return res;
// }

export const _filterationProducts = async (numProducts , page , fields ="" ) =>{
    const res = (await apiInstance.get(`/product?limit=${numProducts}&skip=${page}&${fields && `fields=${fields}`}`)).data
    return res;
}

export const getAllProducts = async () =>{
    const res = (await apiInstance.get(`/product/all`)).data
    return res;
}


export const getProduct = async (id) =>{
    const res = await apiInstance.get(`/product/${id}`)
    return res;
}

export const getSegnents_Fields = async () =>{
    const res = (await apiInstance.get(`/product/segment-field`)).data
    return res;
}


export const addProduct = async(sendedData)=>{
    const res = (await apiInstance.post("/product/",sendedData)).data
    return res;
}

export const deleteProduct = async(productID)=>{
    const res = (await apiInstance.delete(`/product/${productID}`)).data
    return res;
}

export const addImages = async(sendedData , id)=>{
    const res = (await apiInstance.postForm(`/product/images/${id}`,sendedData )).data
    return res;
}


export const updateProduct = async(sendedData , id)=>{
    const res = (await apiInstance.put(`/product/${id}`,sendedData)).data
    return res;
}


export const uploadCloud = async (images)=>{
    const res = await axios.post(`https://api.Cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,images)
    return res;
}

export const destoryCloud = async(public_id)=>{
    const timestamp = new Date().getTime();
    const signature = sha1(`public_id=${public_id}&timestamp=${timestamp}${API_SECRET}`)
    const res = await  axios.post(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/destroy`,{
        public_id,
        api_key:'922268837629582',
        signature,
        timestamp
    })
    return res
}


// delete data make it with custom hook useRequest